/** Mon-Sun week containing (or offset from) the reference date. */
export function getWeekRange(offset: number): { start: Date; end: Date; label: string } {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0=Sun
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const monday = new Date(now);
  monday.setDate(now.getDate() + mondayOffset + offset * 7);
  monday.setHours(0, 0, 0, 0);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const fmt = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });
  const label = `${fmt.format(monday)} - ${fmt.format(sunday)}, ${sunday.getFullYear()}`;
  return { start: monday, end: sunday, label };
}

/** YYYY-MM-DD from a Date in the browser's local timezone. */
export function toLocalDateStr(d?: Date): string {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** First and last day of the calendar month containing the reference date. */
export function getMonthRange(ref?: Date): { start: Date; end: Date } {
  const d = ref ?? new Date();
  const start = new Date(d.getFullYear(), d.getMonth(), 1);
  const end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return { start, end };
}

/** IANA timezone from the browser. */
export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/** Shift a YYYY-MM-DD string by whole days (handles month/year rollover). */
export function shiftDateStr(dateStr: string, deltaDays: number): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + deltaDays);
  return toLocalDateStr(dt);
}

/** Today as a { start, end } range where both are the same YYYY-MM-DD. */
export function getTodayRange(): { start: string; end: string } {
  const d = new Date();
  const str = toLocalDateStr(d);
  return { start: str, end: str };
}
